export interface ActionStateModel {
  isLoading: boolean;
  done: boolean;
  error: boolean;
}
